export default "__VITE_ASSET__CiDV2qRQ__"